
export function toTree(array, id_key, pid_key, pid) {
  var res = []
  var tmp = null
  var arrayLength = array.length
  for (var i = 0; i < arrayLength; i++) {

    if (array[i][pid_key] === pid) {
      tmp = toTree(array, id_key, pid_key, array[i][id_key])
      if (tmp.length > 0) {
        array[i]['children'] = tmp
      }
      res.push(array[i])
    }
  }
  return res
}
export default toTree



// WEBPACK FOOTER //
// ./src/utils/to_tree.js